import { graphql } from 'gatsby';
import * as React from 'react';
import parse from 'html-react-parser';
import { notEmpty } from '../utils/common';
import { siteUrl } from '../../config';

interface Props {
  data: Queries.PostTypeSEOFragment | Queries.TaxonomySEOFragment;
}

export default function SEO({ data }: Props) {
  const robotsText = [
    data.metaRobotsNoindex,
    data.metaRobotsNofollow,
    'max-image-preview:large',
    'max-snippet:-1',
    'max-video-preview:-1',
  ]
    .filter(notEmpty)
    .join(', ');

  // Convert relative image paths into absolute ones,
  // some meta tags such as og:image do not support relative paths
  const fullHead = data.fullHead?.replace(/"\/static\//g, `"${siteUrl}/static/`);

  return (
    <>
      <html lang="en" />
      <meta name="robots" content={robotsText} />
      {data.title && <title>{data.title}</title>}
      {fullHead ? parse(fullHead) : null}
    </>
  );
}

// For single post type pages
export const PostTypeSEOFragment = graphql`
  fragment PostTypeSEO on WpPostTypeSEO {
    title
    metaRobotsNoindex
    metaRobotsNofollow
    fullHead
  }
`;

// For taxonomy pages
export const TaxonomySEOFragment = graphql`
  fragment TaxonomySEO on WpTaxonomySEO {
    title
    metaRobotsNoindex
    metaRobotsNofollow
    fullHead
  }
`;
